import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemText, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import api from '../../../config/axios-instance';
import { ENV } from '../../../config/config';
import navConfig from './config';
import useResponsive from '../../../hooks/useResponsive';
import Scrollbar from '../../../components/scrollbar';
import { StyledNavItemIcon } from '../../../components/nav-section/styles';

const NAV_WIDTH = 280;

const Nav = ({ openNav, onCloseNav }) => {
    const { pathname } = useLocation();
    const [isAlertTriggered, setIsAlertTriggered] = useState(false);
    const isDesktop = useResponsive('up', 'lg');
    const [openSubmenus, setOpenSubmenus] = useState({});

    const toggleSubmenu = (name) => {
        setOpenSubmenus((prevOpenSubmenus) => ({
            ...prevOpenSubmenus,
            [name]: !prevOpenSubmenus[name],
        }));
    };

// useEffect(() => {
//     const fetchAlertStatus = async () => {
//         try {
//             const params = { isNotify: true };
//             const response = await api.get(`${ENV.appBaseUrl}/admin/loan-requests`, { params });
//             if (response?.data?.success) {
//                 const loanRequests = response?.data?.loanRequests;
//                 const hasNotification = loanRequests.some((loan) => loan.isNotify === true);
//                 setIsAlertTriggered(hasNotification);
//             } else {
//                 setIsAlertTriggered(false);
//             }
//         } catch (error) {
//             console.error('Error fetching alert status', error);
//             setIsAlertTriggered(false);
//         }
//     };

//     fetchAlertStatus();

//     const interval = setInterval(fetchAlertStatus, 5000);
//     return () => clearInterval(interval);
// }, []);


    /**
     * Render sidebar menus and submenus without permissions.
     */
    const renderNavItem = (item) => {
        const { icon } = item;
        const hasSubmenu = item.submenu && item.submenu.length > 0;
        const isActive = pathname === item.path;
const isAlertTab = item.title === 'Alert';
    const alertStyles = isAlertTab && isAlertTriggered
        ? { backgroundColor: '#d32f2f', color: '#fff' }
        : {};
       return (
    <>
        <ListItem
            button
            onClick={() => (hasSubmenu ? toggleSubmenu(item.title) : onCloseNav())}
            component={hasSubmenu ? 'div' : Link}
            to={item.path}
            selected={pathname === item.path}
            className={isActive ? 'active' : ''}
            sx={{
                ...alertStyles,
                '&.Mui-selected': {
                    backgroundColor: isAlertTab && isAlertTriggered ? '#b71c1c' : 'action.selected',
                    color: isAlertTab && isAlertTriggered ? '#fff' : 'inherit',
                },
            }}
        >
            <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
            <ListItemText primary={item.title} />
            {hasSubmenu ? (openSubmenus[item.title] ? <ExpandLess /> : <ExpandMore />) : null}
        </ListItem>
        {hasSubmenu && (
            <Collapse in={openSubmenus[item.title]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {item.submenu.map((subitem) => (
                        <ListItem
                            button
                            key={subitem.title}
                            component={Link}
                            to={subitem.path}
                            onClick={onCloseNav}
                            selected={pathname === subitem.path}
                            className={pathname === subitem.path ? 'active' : ''}
                        >
                            <StyledNavItemIcon>{subitem.icon && subitem.icon}</StyledNavItemIcon>
                            <ListItemText primary={subitem.title} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        )}
    </>
);

    };

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
            }}
        >
            <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
                <img src="/assets/illustrations/site_logo.svg" alt="login" className="" />
                {/* <img src={`${process.env.PUBLIC_URL}/assets/icons/site-logo.png`} alt="Logo" /> */}
            </Box>

            {navConfig.map((item) => renderNavItem(item))}

            <Box sx={{ flexGrow: 1 }} />
        </Scrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { lg: 0 },
                width: { lg: NAV_WIDTH },
            }}
        >
            {isDesktop ? (
                <Drawer
                    open
                    variant="permanent"
                    PaperProps={{
                        sx: {
                            width: NAV_WIDTH,
                            bgcolor: 'background.default',
                            borderRightStyle: 'dashed',
                        },
                    }}
                >
                    {renderContent}
                </Drawer>
            ) : (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    PaperProps={{
                        sx: { width: NAV_WIDTH },
                    }}
                >
                    {renderContent}
                </Drawer>
            )}
        </Box>
    );
};

export default Nav;
